/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconMoodSmileDizzy = createReactComponent("outline", "mood-smile-dizzy", "IconMoodSmileDizzy", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M14.5 15a3.5 3.5 0 0 1 -5 0", "key": "svg-1" }], ["path", { "d": "M8 9l2 2", "key": "svg-2" }], ["path", { "d": "M10 9l-2 2", "key": "svg-3" }], ["path", { "d": "M14 9l2 2", "key": "svg-4" }], ["path", { "d": "M16 9l-2 2", "key": "svg-5" }]]);

export { IconMoodSmileDizzy as default };
//# sourceMappingURL=IconMoodSmileDizzy.mjs.map
